import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var ValidationHandlerService = /** @class */ (function () {
    function ValidationHandlerService() {
        this._validationErrorsSubject = new Subject();
        this._validationDisplaySubject = new BehaviorSubject(true);
    }
    Object.defineProperty(ValidationHandlerService.prototype, "validationErrorsSubject", {
        get: function () {
            return this._validationErrorsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ValidationHandlerService.prototype.updateErrors = function (errors) {
        this._validationErrorsSubject.next(errors);
    };
    Object.defineProperty(ValidationHandlerService.prototype, "validationDisplaySubject", {
        get: function () {
            return this._validationDisplaySubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ValidationHandlerService.prototype.shouldDisplayErrors = function (display) {
        this._validationDisplaySubject.next(display);
    };
    ValidationHandlerService.prototype.resetErrors = function () {
        this._validationErrorsSubject.next([]);
        this._validationDisplaySubject.next(false);
    };
    return ValidationHandlerService;
}());
export { ValidationHandlerService };



// WEBPACK FOOTER //
// ./src/app/core/validation-handler.service.ts.pre-build-optimizer.js